import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const ContactContainer = styled.div`
  padding: 4rem;
  width: 100%;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;

const SubTitle = styled(motion.p)`
  color: #666;
  letter-spacing: 3px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
`;

const Title = styled(motion.h2)`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  font-family: 'Playfair Display', serif;
  color: #333;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 768px) {
    gap: 1.2rem;
  }
`;

const Input = styled.input`
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  
  @media (max-width: 768px) {
    padding: 0.8rem;
    font-size: 0.95rem;
  }
  
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

const TextArea = styled.textarea`
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
  
  @media (max-width: 768px) {
    padding: 0.8rem;
    font-size: 0.95rem;
    min-height: 120px;
  }
  
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

const SubmitButton = styled.button`
  padding: 1rem 2rem;
  background: #0066cc;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
  }

  &:hover {
    background: #0052a3;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  svg {
    font-size: 1.5rem;
    color: #0066cc;

    @media (max-width: 768px) {
      font-size: 1.3rem;
    }
  }
`;

const ContactText = styled.div`
  h4 {
    color: #333;
    margin-bottom: 0.5rem;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }
  
  p {
    color: #666;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
`;

const Contact = () => {
  return (
    <ContactContainer>
      <Content>
        <SubTitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          GET IN TOUCH
        </SubTitle>
        <Title
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          CONTACT ME
        </Title>

        <ContactGrid>
          <ContactForm>
            <Input type="text" placeholder="Your Name" />
            <Input type="email" placeholder="Your Email" />
            <Input type="text" placeholder="Subject" />
            <TextArea placeholder="Your Message" />
            <SubmitButton type="submit">Send Message</SubmitButton>
          </ContactForm>

          <ContactInfo>
            <ContactItem>
              <FaEnvelope />
              <ContactText>
                <h4>Email</h4>
                <p>shlokesonker06@gmail.com</p>
              </ContactText>
            </ContactItem>
            <ContactItem>
              <FaPhone />
              <ContactText>
                <h4>Phone</h4>
                <p>+91 8470948855 </p>
              </ContactText>
            </ContactItem>
            <ContactItem>
              <FaMapMarkerAlt />
              <ContactText>
                <h4>Address</h4>
                <p>Kanpur, Uttar Pradesh</p>
              </ContactText>
            </ContactItem>
          </ContactInfo>
        </ContactGrid>
      </Content>
    </ContactContainer>
  );
};

export default Contact; 